import axios from 'axios';

import { getV1RootUrl, publicAxiosHeader } from 'common/helpers/apiHelper';

export const listProducts = (slug, cartId, customerId, qString, page) => {
  let urlString = ``;
  if (slug) {
    urlString += `&collectionSlug=${slug}`;
  }
  if (cartId) {
    urlString += `&cartId=${cartId}`;
  }
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  if (qString) {
    urlString += `${qString}`;
  }
  if (page) {
    urlString += `&page=${page}`;
  }
  return axios.get(
    `${getV1RootUrl()}/product/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const getProduct = (slug, cartId, customerId) => {
  let urlString = '';
  if (cartId) {
    urlString += `&cartId=${cartId}`;
  }
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV1RootUrl()}/product/slug/${slug}/for-web?${urlString}`,
    publicAxiosHeader()
  );
};
